var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInterior = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6.5,4 A 1.5,1.5 0 0,1 9.5,4 L 9.5,6 A 1.5,1.5 0 0,1 6.5,6 L 6.5,4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.5,5 L 9.5,5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.5,4 A 1.5,1.5 0 0,1 18.5,4 L 18.5,6 A 1.5,1.5 0 0,1 15.5,6 L 15.5,4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.5,5 L 18.5,5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.6,9.9 C 4.2,9.5 5,9.7 5.3,10.4 L 7.7,15.5 L 10.8,15.5 A 1,1 0 0,1 10.8,17.5 L 6.8,17.5 A 1,1 0 0,1 5.9,16.9 L 3.2,11.2 C 2.9,10.6 3,10.2 3.6,9.9 L 3.6,9.9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 7,19.5 C 7,18.6 7.7,18 8.5,18 C 9.3,18 10,18.6 10,19.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.5,17.5 L 8.5,18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.6,9.9 C 13.2,9.5 14,9.7 14.3,10.4 L 16.7,15.5 L 19.8,15.5 A 1,1 0 0,1 19.8,17.5 L 15.8,17.5 A 1,1 0 0,1 14.9,16.9 L 12.2,11.2 C 11.9,10.6 12,10.2 12.6,9.9 L 12.6,9.9",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 16,19.5 C 16,18.6 16.7,18 17.5,18 C 18.3,18 19,18.6 19,19.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 17.5,17.5 L 17.5,18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 2,19.5 L 22,19.5 L 22,21.5 L 2,21.5 L 2,19.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInterior, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/interior.61413a27.svg";
export { ForwardRef as ReactComponent };